
import * as defaultImport from "@splunk/themes/mixins";
export * from "@splunk/themes/mixins";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
